<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <router-link
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          to="/add-delivery-stock-notes"
        >
          Nouveau bon de livraison
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </router-link>
      </div>
      <div class="d-sm-flex align-items-center"></div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="row mb-20">
        <div class="col-md-6 d-flex align-items-center">
          <label>Voir</label>
          <v-select
            v-model="filters.per_page"
            :options="[10, 25, 50]"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
            @input="getRecords()"
          />
          <label>sur {{ filters.total }} entités</label>
        </div>
        <div class="col-md-6 d-flex align-items-center">
          <input
            type="text"
            class="form-control shadow-none text-black rounded-0"
            placeholder="Chercher"
            @change="filter()"
            @input="handleInput"
            v-model="filters.searchTerm"
          />
        </div>
      </div>

      <vue-good-table :columns="columns" :rows="rows" :loading="isLoader">
        <template #emptystate>
          <center>Aucune entrées correspondantes trouvées</center>
        </template>

        <template #table-row="props">
          <template v-if="props.column.field === 'note_stock_ref'">
            <b>{{ props.row.note_stock_ref }}</b>
          </template>

          <template v-else-if="props.column.field === 'created_at'">
            {{ getDate(props.row.created_at) }}
          </template>

          <template
            v-else-if="props.column.field === 'note_stock_total_parcel'"
          >
            {{ props.row.note_stock_total_parcel }} Colis
          </template>
          <template v-else-if="props.column.field === 'note_stock_total_crbt'">
            {{ props.row.note_stock_total_crbt }} DH
          </template>

          <template v-else-if="props.column.field === 'note_stock_delivered'">
            <span
              v-if="props.row.note_stock_delivered == 0"
              :class="`badge rounded-pill fs-13 text-bg-${resolveUserStatusVariant(
                props.row.note_stock_delivered
              )}`"
              class="text-capitalize"
            >
              Nouveau
            </span>
            <span
              v-else
              :class="`badge rounded-pill fs-13 text-bg-${resolveUserStatusVariant(
                props.row.note_stock_delivered
              )}`"
              class="text-capitalize"
            >
              Enregistré
            </span>
          </template>

          <template v-else-if="props.column.field === 'action'">
            <div class="dropdown">
              <button
                class="dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <li >
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    :to="{
                      name: 'EditNoteBLStockPage',
                      params: {
                        id: props.row.id,
                        refNote: props.row.note_stock_ref,
                      },
                    }"
                  >
                    <i
                      class="flaticon-pen lh-1 me-8 position-relative top-1"
                    ></i>
                    Modifier
                  </router-link>
                </li>
                <li
                  v-if="
                    
                    props.row.note_stock_total_parcel == 0 &&
                    props.row.note_stock_delivered == 0
                  "
                >
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="removeBL(props.row.id)"
                  >
                    <i
                      class="flaticon-delete lh-1 me-8 position-relative top-1"
                    ></i>
                    Supprimer
                  </a>
                </li>
                <li
                  v-if="
                    
                    props.row.note_stock_delivered == 0 &&
                    props.row.note_stock_total_parcel != 0
                  "
                >
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="saveBL(props.row.id)"
                  >
                    <i
                      class="flaticon-diskette lh-1 me-8 position-relative top-1"
                    ></i>
                    Enregistrer
                  </a>
                </li>

                <li>
                  <a
                    v-if="
                       props.row.note_stock_total_parcel != 0
                    "
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="getPDF(props.row)"
                  >
                    <i
                      class="flaticon-printer lh-1 me-8 position-relative top-1"
                    ></i>
                    PDF
                  </a>
                </li>

                <li>
                  <a
                    v-if="
                      props.row.note_stock_total_parcel != 0
                    "
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="ticketsPDF(props.row)"
                  >
                    <i
                      class="flaticon-menu lh-1 me-8 position-relative top-1"
                    ></i>
                    Tickets
                  </a>
                </li>

                <li>
                  <a
                    v-if="
                      props.row.note_stock_total_parcel != 0
                    "
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="tickets4PDF(props.row)"
                  >
                    <i
                      class="flaticon-more-1 lh-1 me-8 position-relative top-1"
                    ></i>
                    Tickets 4*4
                  </a>
                </li>
              </ul>
            </div>
          </template>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="filters"
        :offset="9"
        @paginate="getRecords()"
      />
    </div>
  </div>
</template>

<script  lang="ts">
import { onMounted, reactive, ref } from "vue";
import flatpickr from "flatpickr";
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import moment from "moment";
import { useAuthStore } from "@/stores/auth";
import Swal from "sweetalert2";

export default {
  name: "ListeNotes",
  components: {},
  setup: () => {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const rows = ref([]);
    const isLoader = ref(false);
    const columns = [
      {
        label: "Référence",
        field: "note_stock_ref",
      },
      {
        label: "Date de création",
        field: "created_at",
        width: "180px",
      },
      {
        label: "Agence",
        field: "note_stock_agency_name",
      },
      {
        label: "Statut",
        field: "note_stock_delivered",
      },
      {
        label: "Colis",
        field: "note_stock_total_parcel",
      },
      {
        label: "Total",
        field: "note_stock_total_crbt",
      },
      {
        label: "Action",
        field: "action",
      },
    ];
    const filters = reactive({
      searchTerm: "",
      searchCustomer: "",
      searchStatut: "",
      searchAgency: "",
      searchDate: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    async function getRecords() {
      isLoader.value = true;
      try {
        const response = await api.get(
          `/api/auth/List_Bls?searchCustomer=${filters.searchCustomer}&searchAgency=${filters.searchAgency}&searchStatut=${filters.searchStatut}&searchDate=${filters.searchDate}&searchTerm=${filters.searchTerm}&page=${filters.current_page}&per_page=${filters.per_page}`
        );

        rows.value = response.data.users.data;
        Object.assign(filters, response.data.users);
      } catch (error) {
        console.error("Erreur lors du chargement des enregistrements:", error);
      } finally {
        isLoader.value = false;
      }
    }

    function getDate(value) {
      return moment(String(value)).format("YYYY-MM-DD HH:mm");
    }
    function resolveUserStatusVariant(status) {
      if (status == 0) return "warning";
      if (status == 1) return "info";
      return "danger";
    }

    function filter() {
      //   filters.searchCustomer = this.customer_filter.id
      //   filters.searchStatut = this.status_filter
      //   filters.searchStore = this.store_filter.id
      //   filters.searchSDate = (this.$refs.myInput.dateRange.start == undefined || this.$refs.myInput.dateRange.start == 'undefined') ? '' : this.convert(this.$refs.myInput.dateRange.start)
      //   filters.searchEDate = (this.$refs.myInput.dateRange.end == undefined || this.$refs.myInput.dateRange.end == 'undefined') ? '' : this.convert(this.$refs.myInput.dateRange.end)
      filters.current_page = 1;
      getRecords();
    }
    function convert(str) {
      const date = new Date(str);
      const mnth = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    }
    function removeFilter() {
      //   filters.searchCustomer = filters.searchStatut = filters.searchStore = "";
      //   this.customer_filter = this.store_filter = { id: '', name: '' }
      //   this.date_filter = this.status_filter = this.type_date_filter = ''
      //   this.$refs.myInput.dateRange = {}
      filters.current_page = 1;
      getRecords();
    }
    function handleInput() {
      //   // Clear previous debounce timer
      //   clearTimeout(this.debounceTimer);

      //   // Set a new debounce timer
      //   this.debounceTimer = setTimeout(() => {
      //     if (!this.searchTerm || this.searchTerm === '') {
      //     filters.searchTerm = this.searchTerm
      //     this.filter()
      //   } else if (this.searchTerm && this.searchTerm.length > 4) {
      //     filters.searchTerm = this.searchTerm
      //     this.filter()
      //   }
      //   }, 500); // Adjust the delay (in milliseconds) as needed
      filter();
    }

    async function removeBL(id) {
      const data = new FormData();
      data.append("bl_id", id);

      const result = await Swal.fire({
        text: "Vous voulez supprimer ce bon de livraison ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      });

      if (result.isConfirmed) {
        try {
          const res = await api.post(`/api/auth/remove_bls`, data);

          if (res.data.message === "success") {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Le bon de livraison est bien supprimé",
              showConfirmButton: false,
              timer: 1500,
            });

            getRecords(); // 🔹 if you are using Composition API. If still in Options API, keep `this.getRecords()`.
          } else if (res.data.message === "Issaved") {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Vous pouvez pas le supprimer!",
            });
          }
        } catch (error) {
          console.error("Erreur suppression BL:", error);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong! Veuillez réessayer",
          });
        }
      }
    }

    async function saveBL(id) {
      try {
        const res = await api.post(`/api/auth/save_bls/${id}`);

        if (res.data.message === "success") {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Le bon de livraison est bien enregistré",
            showConfirmButton: false,
            timer: 1500,
          });

          getRecords(); // 🔹 if Composition API. Use `this.getRecords()` if Options API.
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Erreur, merci de réessayer encore!",
          });
        }
      } catch (error) {
        console.error("Erreur API SaveBL:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong! Veuillez réessayer",
        });
      }
    }

    async function getPDF(row) {
      try {
        const response = await api.get(`/api/auth/DeliveryPDF/${row.id}`, {
          responseType: "arraybuffer",
        });

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        window.open(url, "_blank");
      } catch (error) {
        console.error("Erreur génération PDF:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Impossible de générer le PDF",
        });
      }
    }

    async function ticketsPDF(row) {
      try {
        const response = await api.get(`/api/auth/TicketsInvPDF/${row.id}`, {
          responseType: "arraybuffer",
        });

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        window.open(url, "_blank");
      } catch (error) {
        console.error("Erreur génération TicketsPDF:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Impossible de générer le PDF des tickets",
        });
      }
    }

    async function tickets4PDF(row) {
      try {
        const response = await api.get(`/api/auth/TicketsInv4PDF/${row.id}`, {
          responseType: "arraybuffer",
        });

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        window.open(url, "_blank");
      } catch (error) {
        console.error("Erreur génération Tickets4PDF:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Impossible de générer le PDF (4 tickets)",
        });
      }
    }

     onMounted( () => {
         getRecords();
      });

    return {
      auth,
      rows,
      isLoader,
      columns,
      filters,
      getRecords,
      getDate,
      resolveUserStatusVariant,
      filter,
      convert,
      removeFilter,
      handleInput,
      tickets4PDF,
      removeBL,
      saveBL,
      getPDF,
      ticketsPDF,
    };
  },
};
</script>
